/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonRsvpFloorDayPlan,
    JsonRsvpFloorDayPlanFromJSON,
    JsonRsvpFloorDayPlanFromJSONTyped,
    JsonRsvpFloorDayPlanToJSON,
} from './JsonRsvpFloorDayPlan';

/**
 * 
 * @export
 * @interface ApiResultOfJsonRsvpFloorDayPlan
 */
export interface ApiResultOfJsonRsvpFloorDayPlan {
    /**
     * 
     * @type {JsonRsvpFloorDayPlan}
     * @memberof ApiResultOfJsonRsvpFloorDayPlan
     */
    data?: JsonRsvpFloorDayPlan;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonRsvpFloorDayPlan
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonRsvpFloorDayPlan
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonRsvpFloorDayPlan
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonRsvpFloorDayPlan
     */
    result?: ApiResultOfJsonRsvpFloorDayPlanResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonRsvpFloorDayPlanResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonRsvpFloorDayPlanFromJSON(json: any): ApiResultOfJsonRsvpFloorDayPlan {
    return ApiResultOfJsonRsvpFloorDayPlanFromJSONTyped(json, false);
}

export function ApiResultOfJsonRsvpFloorDayPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonRsvpFloorDayPlan {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonRsvpFloorDayPlanFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonRsvpFloorDayPlanToJSON(value?: ApiResultOfJsonRsvpFloorDayPlan | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonRsvpFloorDayPlanToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

